import {useEffect, useRef} from "react";

import {clearView, viewCriteria} from "@redux/slices/criteriaSlices/viewSlice";
import {BackButton} from "@ui/buttons/BackButton";
import {ViewTitle} from "@ui/forms/ViewTitle";
import {BorderArticle} from "@ui/general/BorderArticle";
import {Spinner} from "@ui/general/Spinner";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate, useParams} from "react-router-dom";

import {CriteriaSectionsList} from "./components/CriteriaSectionsList";
import {normalizeCriteriaTarget} from "./components/criteriaGridHelpers";
import styles from "./styles.module.scss";

export const CriteriaViewPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {id} = useParams();

  const {isMobile} = useSelector((state) => state.common.settings);
  const {current, status} = useSelector((state) => state.criteria.view);

  const criteriaRef = useRef();
  const normalizedCurrent = current ? normalizeCriteriaTarget(current) : null;

  const handleClickEdit = () => {
    navigate(`/admin-panel/criteria/edit/${id}`, {state: {id}});
  };

  useEffect(() => {
    dispatch(viewCriteria({id}));

    return () => {
      dispatch(clearView());
    };
  }, [dispatch, id]);

  useEffect(() => {
    if (criteriaRef.current && isMobile) {
      criteriaRef.current.scrollIntoView({behavior: "smooth"});
    }
  }, [isMobile]);

  return (
    <div
      ref={criteriaRef}
      className={styles.criteriaWrapper}
    >
      <BorderArticle>
        <div className={styles.criteria}>
          <BackButton />

          {status === "loading" || !normalizedCurrent ? (
            <Spinner
              width={80}
              height={80}
            />
          ) : (
            <div className={styles.criteriaContent}>
              <div className={styles.criteriaContentHeadWrapper}>
                <div className={styles.criteriaContentHead}>
                  <ViewTitle
                    value={normalizedCurrent.name || "-"}
                    handleClickEdit={handleClickEdit}
                  />
                </div>
              </div>

              <CriteriaSectionsList
                target={normalizedCurrent}
                readOnly
              />
            </div>
          )}
        </div>
      </BorderArticle>
    </div>
  );
};
